<template>
  <section id="portfolio">
    <navigation :dark="true"></navigation>
    <section class="item">
      <bacon :title="item.title"></bacon>
      <div class="scope">
        <h2 v-for="scope in item.scope">{{scope}}</h2>
      </div>
      <p class="idea" v-html="item.idea"></p>

      <div class="media-item" v-for="media in item.media" :class="media.type" :key="media.id">
        <h3>{{ media.title }}</h3>
        <div class="images">
          <img v-if="['logo', 'palette'].includes(media.type)" :src="'/dist/' + media.url " />
          <div v-else-if="'fonts' == media.type" v-for="img in media.url" >
            <img :src="'/dist/' + img" />
          </div>
          <template v-else-if="'grid' == media.type">
            <div v-for="image,i in media.images" :class="image.size" class="grid-item"
                 v-on:click="grid.selected = i; grid.open = true"
                 :style="{ 'background-image': 'url(/dist/' + image.url + ')' }">
            </div>
            <gallery name="mood" :images="media.images.map( function(el){return el.url})" :obj="grid" ></gallery>

          </template>
          <div v-else-if="'video' == media.type" class="video-wrapper">
            <iframe :src="media.url" frameborder="0" allowfullscreen></iframe>
          </div>
          <template v-else>
            <div v-for="image, i in media.url" class="thumb">
              <img :src="'/dist/' + image " v-on:click="mood.selected = i; mood.open = true"/>
            </div>
            <gallery name="grid" :images="media.url" :obj="mood" ></gallery>
          </template>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
  import Navigation from '../components/navigation.vue';
  import Bacon from '../components/bacon.vue';
  import Gallery from '../components/galery.vue';
  require.context('../../assets/portfolio/', true);

  export default {
    components: {Navigation, Bacon, Gallery},
    props: {
      id: String,
      name: String,
    },
    watch: {
      '$route': function() {
        this.item = require('../portfolio.json')[this.$route.params.id];
        this.itemId = this.$route.params.id;
        document.body.scrollTop = 0;
      }
    },

    data () {
      return {
        item: require('../portfolio.json')[this.$route.params.id],
        itemId: this.$route.params.id,
        mood: {
          selected: 0,
          open: false,
        },
        grid: {
          selected: 0,
          open: false,
        }
      }
    },
  }
</script>

<style lang="scss">
  @import "../../css/main.scss";
  @import "../../css/portfolio.scss";
</style>


// WEBPACK FOOTER //
// item.vue?3a7bd3ed